const raffle = {
  // 获取抽奖基础信息 ---- 李健
  lotteryBasic: `/authApi/lottery/basic`,
  // 获取当前用户抽奖券总数以及中奖飘屏信息 ---- 李健
  screenInfo: `/authApi/lottery/v1/lottery/home/page`,
  // 进行中的抽奖期数 ---- 李健
  runningLottery: `/authApi/lottery/v1/running/lottery/period`,
  // 历史开奖期数信息 ---- 李健
  historyLottery: `/authApi/lottery/v1/history/lottery/period`,
  // 用户抽奖期数信息 ---- 李健
  userLottery: `/authApi/lottery/v1/user/lottery/period`,
  // 获取奖池中奖结果 ---- 李健
  poolWinInfo: `/authApi/lottery/v1/lottery/pool/win/info`,
  // 获取奖池期数用户抽奖券信息 ---- 李健
  userTicketNum: `/authApi/lottery/v1/user/ticketNum`,
  // 获取更多抽奖券接口 ---- 林加汉
  obtainTicket: `/authApi/lottery/v1/activity/entrance`,
  // 过期券展示关闭事件上报 ---- 林加汉
  ticketExpireClose: `/authApi/lottery/ticket/expire/close/report`,
  // 使用兑换码 ---- 李健
  useCode: `/authApi/lottery/use/redemption/code`,
  // 获取用户中奖信息 ---- 李健
  userWinList: `/authApi/lottery/v1/user/win/list`,
  // 获取用户奖品虚拟信息 ---- 李健
  userVirtual: `/authApi/lottery/v1/user/virtual/prize`,
  // 查看卡密-获取短信验证码 ---- 李健
  codeVirtual: `/authApi/lottery/v1/virtual/code`,
  // 下发虚拟奖品 ---- 李健
  distributeVirtual: `/authApi/lottery/v1/distribute/virtual/prize`,
  // 确认收货地址 ---- 李健
  confirmAddress: `/authApi/lottery/confirm/address`,
  // 查看物流信息 ---- 李健
  prizeLogistic: `/authApi/logistics/v1/rewordQuery`,
  // 更新物流地址 ---- 李健
  editLogisticAddress: `/authApi/lottery/edit/logistic/address`,
  // 券消耗明细 ---- 李健
  consumeDetail: `/authApi/lottery/v1/ticket/consume/detail`,
  // 获取用户生效中的抽奖券 ---- 李健
  effectiveDetail: `/authApi/lottery/v1/user/effective/lottery/ticket`,
  // 查询所有收货地址 ---- 李健
  queryUserShippingAddressAll: `/authApi/user/v1/queryUserShippingAddressAll`,
  // 删除收货地址 ---- 李健
  delUserShippingAddress: `/authApi/user/v1/delUserShippingAddress`,
  // 新增收货地址 ---- 李健
  addShippingAddress: `/authApi/user/v1/addShippingAddress`,
  // 编辑收货地址 ---- 李健
  updateShippingAddress: `/authApi/user/v1/updateShippingAddress`,
  // 获取奖池详情信息 ---- 李健
  poolDetail: `/authApi/lottery/v1/lottery/pool/detail`,
  // 投入奖池时获取可使用奖券的数量和类型 ---- 李健
  voteTicketDetail: `/authApi/lottery/v1/ticket/detail`,
  // 奖券确认投入奖池 ---- 李健
  voteTicketConfirm: `/authApi/lottery/v1/ticket/use/confirm`,
  // 游戏详情页是否展示抽奖入口 ---- 李健
  lotteryEntrance: `/authApi/lottery/activity/server/entrance`,
  // 获取区服抽奖详细信息 ---- 李健
  gameLotteryDetail: `/authApi/lottery/game/lottery/detail`,
  // 生成邀请码 ---- 李健
  inviteCode: `/authApi/activity/a1013/generate/invite/code`,
  // 查询游戏等级 ---- 李健
  searchGameRank: `/authApi/activity/a1013/search/game/info`,
  // 填写邀请码 ---- 李健
  useInviteCode: `/authApi/activity/a1013/use/invite/code`
};

export default raffle;
